import { useLayoutEffect, useState } from 'react';
import { useGetBreakpoint } from '../../utils';

// useWindowSize util for checing the screensize
export const useScreenType = () => {
  const [windowSize, setWindowSize] = useState<string | undefined>();

  const handleSize = () => {
    setWindowSize(useGetBreakpoint);
  };

  useLayoutEffect(() => {
    handleSize();

    window.addEventListener('resize', handleSize);
    return () => window.removeEventListener('resize', handleSize);
  }, []);

  return windowSize;
};
